import type { StrictPost } from '$lib/types'

export const meta: StrictPost = {
	title: 'Letter to Sir Demis Hassabis',
	description:
		'Parliamentarians from across the UK call on Google DeepMind to honour their AI safety commitments',
	date: '2025-08-22',
	slug: 'dear-sir-demis-2025',
	categories: ['AI Safety', 'Transparency', 'Government']
}
